<template>
  <div>
    <Header />
    <Salesordereg />
  </div>
</template>
<script>
import Header from "../components/Header.vue";
import Salesordereg from "../components/Salesorderitemreg.vue";
export default {
  components: {
    Salesordereg,
    Header
  },
  data() {
    return {};
  },
  // beforeRouteLeave(to, from, next) {
  // //  console.log("sample name");
   
  // //   const answer = window.confirm('Do you want to leave this page?');
  // //   if (answer) {
  // //     next();
  // //   } else {
  // //     next(false);
  // //   }

  // }
  
};
</script>
